import styled from 'styled-components';
import theme from '../../assets/styles/theme/theme';

export const ModalOverlay = styled.div`
  & .hefesto-title {
    > h3 {
      color: ${theme.colors.grayDark3};
      font-weight: 600;
      font-size: 24px;
      line-height: 36px;
      margin-bottom: 0;
      white-space: pre-line;
    }
  }
  & .hefesto-title {
    height: 36px;
  }
`;

export const GmaisModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  & span {
    display: block;
  }
`;

export const GmaisModalNeverShowAgainContainer = styled.div`
  margin-top: 28px;
  margin-bottom: 2px;
  margin-left: 5px;
`;
